// Maps short codes (EX, VG, NON, etc.) to human-readable full names.
// Used in tooltips on filter chips (Cut, Symmetry, Polish, Fluorescence...).
// Ported from filterUI/_docThemes/utils/dictionary.js.
export const dictionary = (key) => {
    if (!key) return "";

    const fullFormMap = new Map([
        ["ID", "IDEAL"],
        ["EX", "EXCELLENT"],
        ["VG", "VERY GOOD"],
        ["GD", "GOOD"],
        ["FR", "FAIR"],
        ["PR", "POOR"],
        ["NON", "NONE"],
        ["FNT", "FAINT"],
        ["VSLT", "VERY SLIGHT"],
        ["SLT", "SLIGHT"],
        ["MED", "MEDIUM"],
        ["STG", "STRONG"],
        ["VST", "VERY STRONG"],
        ["naturalFancy", "natural fancy"],
        ["labFancy", "lab fancy"],
    ]);

    return fullFormMap.get(key) || key;
};
